<mat-drawer-container autosize class="page-wrapper">
  <div class="page-content">
    <div class="title-wrapper">
      <h1 class="title">{{$Locale.get("files")}}</h1>
    </div>
    <div class="panel-wrapper">
      <div class="filter-wrapper">
        <dashboard-filter-bar></dashboard-filter-bar>
      </div>
      <div class="table-wrapper">
        <lib-hubio-table [hidden]="data && data.length > 0 ? false : true" #table [options]="tableOptions" (paginationEvent)="handlePaginationEvent($event)"
          (rowClickEvent)="handleRowClick($event)">
        </lib-hubio-table>
        <p *ngIf="data && !data.length" class="empty-data-title">
          <mat-icon>error_outline</mat-icon>
          {{$Locale.get("no_results")}}
        </p>
      </div>
    </div>
  </div>
</mat-drawer-container>